// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.modal-order-products-list {}


#OrderProductList {
  -webkit-user-select: none;
          user-select: none;
  width: 96% !important;
  max-width: 650px !important;
}

@media screen and (max-width: 768px) {}



#OrderProductList .modal-content {
  display: flex;
}


#OrderProductList .modal-content {
  display: flex;
  margin-top: -30px;
}


#OrderProductList .modal-header,
#OrderProductList .modal-footer {
  flex: 0 0;
}





.modal-order-products-list .modal-body {

  max-height: 75vh;
  /* height: 80vh; */
  display: flex;
  flex-wrap: nowrap;
  justify-content: flex-start;
  overflow: hidden;
}

#OrderProductList .wrapper {
  display: flex;
  flex-wrap: nowrap;
  justify-content: flex-start;
  width: 200%;
  height: 100%;
  align-items: flex-start;


  overflow-x: hidden;
}


#OrderProductList ul,
#OrderProductList li {
  list-style: none;
  margin: 0px;
  padding: 0;
}

#OrderProductList h5.cat-name {
  border-radius: 7px;
  background-color: var(--blue-1);
  color: var(--blue);
  border-color: var(--blue);
}

#OrderProductList .slide {
  flex: 0 0 100%;
  width: 100%;
  margin-left: 0;
  transition: margin-left 500ms;
  max-height: 100%;
  overflow-y: auto;
  padding-right: var(--bs-modal-padding);
}

#OrderProductList ul.catalog-items {
  display: flex;
  flex-wrap: wrap;
}

#OrderProductList li.catalog-item {
  border: 1px solid #ddd;
  border-radius: 7px;
  text-align: center;
  padding: 7px;
  margin: 0 10px 10px 0;
  font-size: 0.8rem;
}

#OrderProductList li .top * {
  font-size: 0.8rem;
  line-height: 1.2;
}


#OrderProductList h5 {
  font-size: 0.9rem;
}



#OrderProductList ul.subcategories {}


#OrderProductList ul.subcategories>li {
  flex-grow: 0;
  flex-shrink: 0;
  flex-basis: calc(25% - 10px);
}


#OrderProductList h6.subcat-name {
  font-size: 0.8rem;
}


#OrderProductList ul.products>li {
  flex-grow: 0;
  flex-shrink: 0;
  flex-basis: calc(50% - 10px);
}


#OrderProductList .cover {
  position: relative;
  overflow: hidden;


}


#OrderProductList ul.subcategories .cover {
  width: 100%;
  padding-top: 100%;

}




#OrderProductList .subcategories .cover img {
  border-radius: 7px;
  object-fit: cover;
  width: 100%;
  height: 100%;
  position: absolute;
  top: 0;
  left: 0;
}




#OrderProductList ul.products .cover {
  width: 80px;
  height: 80px;
}




#OrderProductList .cover img {
  border-radius: 7px;
  object-fit: cover;
  width: 100%;
  height: 100%;
}

#OrderProductList ul.products input[type="checkbox"] {
  position: relative;
  top: 1px;
}

#OrderProductList .cat-memo {
  white-space: pre-wrap;
  line-height: 1.1;
  font-size: 0.9rem;
  color: #666;

}

/*








#OrderProductList ul .input-group {
  max-width: 120px;
  margin: 2px auto 0;
  user-select: none;
}


*/
@media screen and (min-width: 768px) {
  .modal-order-products-list .modal-content {
    width: 650px;
  }



}


@media screen and (max-width: 576px) {
  #OrderProductList ul.catalog-items li {
    flex: 1 1;

  }

  #OrderProductList ul.subcategories li {
    flex-grow: 0;
    flex-shrink: 0;
    flex-basis: calc(50% - 10px);

  }


  #OrderProductList ul.products li {
    flex: 1 1 !important;

  }

}`, "",{"version":3,"sources":["webpack://./src/components/orders/order-products-list.css"],"names":[],"mappings":"AAAA,4BAA4B;;;AAG5B;EACE,yBAAiB;UAAjB,iBAAiB;EACjB,qBAAqB;EACrB,2BAA2B;AAC7B;;AAEA,sCAAsC;;;;AAItC;EACE,aAAa;AACf;;;AAGA;EACE,aAAa;EACb,iBAAiB;AACnB;;;AAGA;;EAEE,SAAS;AACX;;;;;;AAMA;;EAEE,gBAAgB;EAChB,kBAAkB;EAClB,aAAa;EACb,iBAAiB;EACjB,2BAA2B;EAC3B,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,iBAAiB;EACjB,2BAA2B;EAC3B,WAAW;EACX,YAAY;EACZ,uBAAuB;;;EAGvB,kBAAkB;AACpB;;;AAGA;;EAEE,gBAAgB;EAChB,WAAW;EACX,UAAU;AACZ;;AAEA;EACE,kBAAkB;EAClB,+BAA+B;EAC/B,kBAAkB;EAClB,yBAAyB;AAC3B;;AAEA;EACE,cAAc;EACd,WAAW;EACX,cAAc;EACd,6BAA6B;EAC7B,gBAAgB;EAChB,gBAAgB;EAChB,sCAAsC;AACxC;;AAEA;EACE,aAAa;EACb,eAAe;AACjB;;AAEA;EACE,sBAAsB;EACtB,kBAAkB;EAClB,kBAAkB;EAClB,YAAY;EACZ,qBAAqB;EACrB,iBAAiB;AACnB;;AAEA;EACE,iBAAiB;EACjB,gBAAgB;AAClB;;;AAGA;EACE,iBAAiB;AACnB;;;;AAIA,oCAAoC;;;AAGpC;EACE,YAA0B;EAA1B,cAA0B;EAA1B,4BAA0B;AAC5B;;;AAGA;EACE,iBAAiB;AACnB;;;AAGA;EACE,YAA0B;EAA1B,cAA0B;EAA1B,4BAA0B;AAC5B;;;AAGA;EACE,kBAAkB;EAClB,gBAAgB;;;AAGlB;;;AAGA;EACE,WAAW;EACX,iBAAiB;;AAEnB;;;;;AAKA;EACE,kBAAkB;EAClB,iBAAiB;EACjB,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,MAAM;EACN,OAAO;AACT;;;;;AAKA;EACE,WAAW;EACX,YAAY;AACd;;;;;AAKA;EACE,kBAAkB;EAClB,iBAAiB;EACjB,WAAW;EACX,YAAY;AACd;;AAEA;EACE,kBAAkB;EAClB,QAAQ;AACV;;AAEA;EACE,qBAAqB;EACrB,gBAAgB;EAChB,iBAAiB;EACjB,WAAW;;AAEb;;AAEA;;;;;;;;;;;;;;;;CAgBC;AACD;EACE;IACE,YAAY;EACd;;;;AAIF;;;AAGA;EACE;IACE,SAAO;;EAET;;EAEA;IACE,YAA0B;IAA1B,cAA0B;IAA1B,4BAA0B;;EAE5B;;;EAGA;IACE,oBAAkB;;EAEpB;;AAEF","sourcesContent":[".modal-order-products-list {}\r\n\r\n\r\n#OrderProductList {\r\n  user-select: none;\r\n  width: 96% !important;\r\n  max-width: 650px !important;\r\n}\r\n\r\n@media screen and (max-width: 768px) {}\r\n\r\n\r\n\r\n#OrderProductList .modal-content {\r\n  display: flex;\r\n}\r\n\r\n\r\n#OrderProductList .modal-content {\r\n  display: flex;\r\n  margin-top: -30px;\r\n}\r\n\r\n\r\n#OrderProductList .modal-header,\r\n#OrderProductList .modal-footer {\r\n  flex: 0 0;\r\n}\r\n\r\n\r\n\r\n\r\n\r\n.modal-order-products-list .modal-body {\r\n\r\n  max-height: 75vh;\r\n  /* height: 80vh; */\r\n  display: flex;\r\n  flex-wrap: nowrap;\r\n  justify-content: flex-start;\r\n  overflow: hidden;\r\n}\r\n\r\n#OrderProductList .wrapper {\r\n  display: flex;\r\n  flex-wrap: nowrap;\r\n  justify-content: flex-start;\r\n  width: 200%;\r\n  height: 100%;\r\n  align-items: flex-start;\r\n\r\n\r\n  overflow-x: hidden;\r\n}\r\n\r\n\r\n#OrderProductList ul,\r\n#OrderProductList li {\r\n  list-style: none;\r\n  margin: 0px;\r\n  padding: 0;\r\n}\r\n\r\n#OrderProductList h5.cat-name {\r\n  border-radius: 7px;\r\n  background-color: var(--blue-1);\r\n  color: var(--blue);\r\n  border-color: var(--blue);\r\n}\r\n\r\n#OrderProductList .slide {\r\n  flex: 0 0 100%;\r\n  width: 100%;\r\n  margin-left: 0;\r\n  transition: margin-left 500ms;\r\n  max-height: 100%;\r\n  overflow-y: auto;\r\n  padding-right: var(--bs-modal-padding);\r\n}\r\n\r\n#OrderProductList ul.catalog-items {\r\n  display: flex;\r\n  flex-wrap: wrap;\r\n}\r\n\r\n#OrderProductList li.catalog-item {\r\n  border: 1px solid #ddd;\r\n  border-radius: 7px;\r\n  text-align: center;\r\n  padding: 7px;\r\n  margin: 0 10px 10px 0;\r\n  font-size: 0.8rem;\r\n}\r\n\r\n#OrderProductList li .top * {\r\n  font-size: 0.8rem;\r\n  line-height: 1.2;\r\n}\r\n\r\n\r\n#OrderProductList h5 {\r\n  font-size: 0.9rem;\r\n}\r\n\r\n\r\n\r\n#OrderProductList ul.subcategories {}\r\n\r\n\r\n#OrderProductList ul.subcategories>li {\r\n  flex: 0 0 calc(25% - 10px);\r\n}\r\n\r\n\r\n#OrderProductList h6.subcat-name {\r\n  font-size: 0.8rem;\r\n}\r\n\r\n\r\n#OrderProductList ul.products>li {\r\n  flex: 0 0 calc(50% - 10px);\r\n}\r\n\r\n\r\n#OrderProductList .cover {\r\n  position: relative;\r\n  overflow: hidden;\r\n\r\n\r\n}\r\n\r\n\r\n#OrderProductList ul.subcategories .cover {\r\n  width: 100%;\r\n  padding-top: 100%;\r\n\r\n}\r\n\r\n\r\n\r\n\r\n#OrderProductList .subcategories .cover img {\r\n  border-radius: 7px;\r\n  object-fit: cover;\r\n  width: 100%;\r\n  height: 100%;\r\n  position: absolute;\r\n  top: 0;\r\n  left: 0;\r\n}\r\n\r\n\r\n\r\n\r\n#OrderProductList ul.products .cover {\r\n  width: 80px;\r\n  height: 80px;\r\n}\r\n\r\n\r\n\r\n\r\n#OrderProductList .cover img {\r\n  border-radius: 7px;\r\n  object-fit: cover;\r\n  width: 100%;\r\n  height: 100%;\r\n}\r\n\r\n#OrderProductList ul.products input[type=\"checkbox\"] {\r\n  position: relative;\r\n  top: 1px;\r\n}\r\n\r\n#OrderProductList .cat-memo {\r\n  white-space: pre-wrap;\r\n  line-height: 1.1;\r\n  font-size: 0.9rem;\r\n  color: #666;\r\n\r\n}\r\n\r\n/*\r\n\r\n\r\n\r\n\r\n\r\n\r\n\r\n\r\n#OrderProductList ul .input-group {\r\n  max-width: 120px;\r\n  margin: 2px auto 0;\r\n  user-select: none;\r\n}\r\n\r\n\r\n*/\r\n@media screen and (min-width: 768px) {\r\n  .modal-order-products-list .modal-content {\r\n    width: 650px;\r\n  }\r\n\r\n\r\n\r\n}\r\n\r\n\r\n@media screen and (max-width: 576px) {\r\n  #OrderProductList ul.catalog-items li {\r\n    flex: 1;\r\n\r\n  }\r\n\r\n  #OrderProductList ul.subcategories li {\r\n    flex: 0 0 calc(50% - 10px);\r\n\r\n  }\r\n\r\n\r\n  #OrderProductList ul.products li {\r\n    flex: 1 !important;\r\n\r\n  }\r\n\r\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
